import { render, staticRenderFns } from "./asset-context-area.vue?vue&type=template&id=64d9bed6&"
import script from "./asset-context-area.vue?vue&type=script&lang=ts&"
export * from "./asset-context-area.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports